import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MultiTokenUser } from '@jms/model';
import { untilDestroyed } from '@jms/utils';

import { delay, tap } from 'rxjs/operators';
import { ShellSelectors } from '../../state/shell.selectors';

@Component({
    selector: 'body',
    templateUrl: './shell.component.html',
    styleUrls: ['./shell.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ShellComponent implements OnInit, OnDestroy {

    public user: MultiTokenUser;

    constructor(
        private cdr: ChangeDetectorRef,
        public selectors: ShellSelectors) {
    }

    ngOnInit(): void {

        this.selectors
            .user$
            .pipe(
                untilDestroyed(this),
                delay(0),
                tap(user => {
                    this.user = user;
                    this.cdr.markForCheck();
                })
            ).subscribe();
    }

    ngOnDestroy() { }
}
